import { render, staticRenderFns } from "./DashboardListBox.vue?vue&type=template&id=71419f70"
import script from "./DashboardListBox.vue?vue&type=script&lang=js"
export * from "./DashboardListBox.vue?vue&type=script&lang=js"
import style0 from "../../../assets/css/Table.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DashboardListBox.vue?vue&type=style&index=1&id=71419f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports